<template>
	<div class="post-smtp-notification-bar-wrapper">

		<div
			v-if="notifications.length"
			v-for="notification in notifications"
			class="post-smtp-notification-wrapper"
			:post-smtp-opened="!notification.opened"
		>
			<a
				href="#"
				@click="( e ) => openNotification( e, notification, admin_url + '?page=postman_email_log&status=failed' )"
				style="text-decoration: none"
			>
				<div class="post-smtp-notification-content-wrapper">
					<div class="full-width-content">
						<div class="left-side-content">
							<h2 class="post-smtp-notification-title">
								<span style="margin-right: 6px;display: inline-block">
									<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M18.0335 14.1727L11.9273 3.6083C11.8346 3.44494 11.7256 3.30335 11.6056 3.1781C10.6188 2.14889 8.84146 2.29047 8.07819 3.6083L1.97198 14.1727C1.75936 14.5322 1.66667 14.9079 1.66667 15.2782C1.66667 15.8609 1.90111 16.4163 2.29365 16.8247C2.68619 17.2386 3.24774 17.5 3.89653 17.5H16.1089C17.4065 17.5 18.3333 16.4381 18.3333 15.2728C18.3333 14.9079 18.2407 14.5322 18.0335 14.1727ZM9.11951 7.43111C9.11951 7.02269 9.45208 6.68506 9.86643 6.68506H10.3626C10.7715 6.68506 11.1095 7.01724 11.1095 7.43111V11.0415C11.1095 11.45 10.7769 11.7876 10.3626 11.7876H9.86643C9.45753 11.7876 9.11951 11.4554 9.11951 11.0415V7.43111ZM10.1172 15.3599C9.39211 15.3599 8.80875 14.7718 8.80875 14.0529C8.80875 13.3287 9.39756 12.746 10.1172 12.746C10.8369 12.746 11.4257 13.3341 11.4257 14.0529C11.4257 14.7772 10.8369 15.3599 10.1172 15.3599Z" fill="#E67373"/>
									</svg>
								</span>
								{{ i18n.title }}
							</h2>
							<p class="post-smtp-notification-content">{{ notification.subject }}</p>
						</div>

						<div style="text-align: right" class="right-side-content notification-timeline">
							{{ notification.delivery_time }}
						</div>
					<div class="clearfix"></div>
					</div>


				</div>
			</a>

			<a
				class="notification-bin left-side-content"
				v-if="notification.opened"
				@click="( e ) => removeNotification( e, notification )"
				style="text-decoration: none;position: absolute;bottom: 20px;right: 20px;z-index: 20;"
			>
				<post-smtp-img :src="plugin_dir_url + 'assets/images/bin.svg'"></post-smtp-img>
			</a>
		</div>

		<div v-else>
			<div class="post-smtp-notification-content-wrapper">
				<div class="left-side-content">

					<h2 class="post-smtp-notification-title">
								<span style="margin-right: 6px;display: inline-block">
									<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M18.0335 14.1727L11.9273 3.6083C11.8346 3.44494 11.7256 3.30335 11.6056 3.1781C10.6188 2.14889 8.84146 2.29047 8.07819 3.6083L1.97198 14.1727C1.75936 14.5322 1.66667 14.9079 1.66667 15.2782C1.66667 15.8609 1.90111 16.4163 2.29365 16.8247C2.68619 17.2386 3.24774 17.5 3.89653 17.5H16.1089C17.4065 17.5 18.3333 16.4381 18.3333 15.2728C18.3333 14.9079 18.2407 14.5322 18.0335 14.1727ZM9.11951 7.43111C9.11951 7.02269 9.45208 6.68506 9.86643 6.68506H10.3626C10.7715 6.68506 11.1095 7.01724 11.1095 7.43111V11.0415C11.1095 11.45 10.7769 11.7876 10.3626 11.7876H9.86643C9.45753 11.7876 9.11951 11.4554 9.11951 11.0415V7.43111ZM10.1172 15.3599C9.39211 15.3599 8.80875 14.7718 8.80875 14.0529C8.80875 13.3287 9.39756 12.746 10.1172 12.746C10.8369 12.746 11.4257 13.3341 11.4257 14.0529C11.4257 14.7772 10.8369 15.3599 10.1172 15.3599Z" fill="#E67373"/>
									</svg>
								</span>
						{{ i18n.title }}
					</h2>
					<p class="post-smtp-notification-content">{{ i18n.description }}</p>
				</div>

				<div class="clearfix"></div>

				<div class="full-width-content mt-10">
					<span class="notification-timeline right-side-content"></span>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
export default {
	name: 'post-smtp-notification-bar',

	props: {
		notifications: {
			type: Array,
			default: () => [],
		},
	},

	data: ( vm ) => ( {
		plugin_dir_url: vm.$parent.plugin_dir_url,
		admin_url: vm.$parent.admin_url,
    i18n: postSmtpNewDashboard.i18n.notification,
	} ),

	methods: {
		openNotification( e, notification, url ) {
			e.preventDefault();

			axios.post( 'open-notification', {
				id: notification.id,
			} )
				.then( response => {
					notification.opened = true
					window.location.href = url;
				} );
		},

		removeNotification( e, notification ) {
			e.preventDefault();

			if ( notification.opened ) {
				axios.post( 'remove-notification/', {
					id: notification.id,
				} )
					.then( response => {
						const index = this.notifications.indexOf( notification );

						if ( index > -1 ) {
							this.notifications.splice( index, 1 );
						}
					} );
			}
		},
	},

	mounted() {
	}
}
</script>

<style scoped>
.post-smtp-notification-bar-wrapper * {
	padding: 0;
	margin: 0;
}

.post-smtp-notification-bar-wrapper {
	width: 380px;
	max-height: 320px;

	box-shadow: 0px 0px 20px 0px rgba(35, 31, 32, 0.10);
	position: absolute;
	top: 60px;
	right: 98px;

	background: #ffffff;
	overflow-y: auto;
	z-index: 1;
}

.post-smtp-notification-wrapper {
	width: calc( 100% - 4px );

	border-radius: 0 4px 0 0;
	background: #FFF8F8;
	border-left: 4px solid #E57373;
	cursor: pointer;

	position: relative;
}

[post-smtp-opened="false"] {
	border-left: none;
	cursor: default;
}

.post-smtp-notification-content-wrapper {
	padding: 16px 20px;
	border-bottom: 1px solid #E5E9F1;
}

.post-smtp-notification-content-wrapper::after {
	content: '';
	display: table;
	clear: both;
}

.post-smtp-notification-title {
	color: #8B8F9A;
	font-family: Poppins;
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 20px; /* 142.857% */
}

[post-smtp-opened="true"] .post-smtp-notification-title {
	color: #B25858;
}

.post-smtp-notification-content {
	color: #8B8F9A;
	font-family: Poppins;
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: 130%; /* 15.6px */

	margin-top: 4px;
}

[post-smtp-opened="true"] .post-smtp-notification-content {
	color: #231F20;
}

.mt-10 {
	margin-top: 10px;
}

.notification-timeline {
	color: #8B8F9A;
	text-align: right;
	font-family: Poppins;
	font-size: 11px;
	font-style: normal;
	font-weight: 400;
	line-height: 20px; /* 181.818% */
}

.left-side-content {
	width: 70%;
	float: left;
}

.full-width-content {
	display: block;
}

.clearfix {
	clear: both;
	display: table;
}

.full-width-content::after {
	content: '';
	display: table;
	clear: both;
}

.right-side-content {
	width: 30%;
	float: right;
}

.right-side-content::after {
	content: '';
	display: table;
	clear: both;
}

.notification-bin {
	display: block;
	width: 16px;
	height: 16px;
}
</style>